import actionTypes from './action-types';
import mutationTypes from './mutation-types';
import consolePanelReq from "../assets/js/request/otherService/consolePanelReq";

export default {
  /**
   * 获取顶部导航栏
   */
  async [actionTypes.GET_NAV_TOP_MENU]({ commit, state }) {
    let navTopMenu = [];
    let result = await consolePanelReq.getNavTopMenu();

    if (Number(result.data.code) === 0) {
      navTopMenu = result.data.res;
    }
    commit(mutationTypes.SET_NAV_TOP_MENU, navTopMenu);
  },

  /**
   * 获取左侧导航栏
   */
  async [actionTypes.GET_NAV_LEFT_MENU]({ commit, state }) {
    let navLeftMenu;

    if (sessionStorage.getItem('navLeftMenu')) {
      navLeftMenu = JSON.parse(sessionStorage.getItem('navLeftMenu'));
      commit(mutationTypes.SET_NAV_LEFT_MENU, navLeftMenu);
    } else {
      let result = await consolePanelReq.getDefaultMenu();
      if (Number(result.data.code) === 0) {
        navLeftMenu = result.data.res;
        sessionStorage.setItem('navLeftMenu', JSON.stringify(navLeftMenu));
        commit(mutationTypes.SET_NAV_LEFT_MENU, navLeftMenu);
      }
    }
  },

  /**
   * 获取新的左侧导航栏
   */
  async [actionTypes.UPDATE_NAV_LEFT_MEUN]({ commit, state }, Payload) {
    commit(mutationTypes.SET_NAV_LEFT_MENU, Payload);

    let params = { list: Payload };
    let result = await consolePanelReq.addCustomMenu(params);
    if (Number(result.data.code) === 0) {}
  },

  /**
   * 获取region
   */
  async [actionTypes.GET_REGION]({ commit, state }) {
    let region = [];
    if (sessionStorage.getItem('ai-region-list') && sessionStorage.getItem('ai-region-list') !== 'undefined') {
      region = JSON.parse(sessionStorage.getItem('ai-region-list'));
      commit(mutationTypes.SET_REGION, region);
    } else {
      let result = await consolePanelReq.getRegion();
      if (Number(result.status) === 200 && result.data.data.List && Array.isArray(result.data.data.List)) {
        region = result.data.data.List;
        sessionStorage.setItem('ai-region-list', JSON.stringify(region));
        commit(mutationTypes.SET_REGION, region);
      }
    }
    commit(mutationTypes.SET_SELECTED_REGION_ID);
  },

  /**
   * 获取userInfo
   */
  async [actionTypes.GET_USER_INFO]({ commit, state }) {
    let userInfo = JSON.parse(localStorage.getItem("user")) || {};
    commit(mutationTypes.SET_USER_INFO, userInfo);
  },

  /**
   * 获取账户余额
   */
  async [actionTypes.GET_ACCOUNT_REMAINDER]({ commit, state }) {
    let accountRemainder = 0;
    if (state.userInfo.type == 'PUBLIC') {
      let result = await consolePanelReq.getAccountRemainder();
      if (Number(result.data.code) === 0 && result.data.res) {
        accountRemainder = result.data.res.availableTotal ? Math.abs(result.data.res.availableTotal.toFixed(2)) === 0 ? Math.abs(result.data.res.availableTotal).toFixed(2) : result.data.res.availableTotal.toFixed(2) : 0;
        // accountRemainder = result.data.res.availableTotal ? result.data.res.availableTotal.toFixed(2) : 0;
      }
      commit(mutationTypes.SET_ACCOUNT_REMAINDER, accountRemainder);
    }
  },


  /**
   * 获取未读消息条数
   */
  async [actionTypes.GET_MESSAGE_COUNT]({ commit, state }) {
    let messageCount;
    let result = await consolePanelReq.getMessageCount();

    if (Number(result.data.code) === 0) {
      messageCount = result.data.res;
    }
    commit(mutationTypes.SET_MESSAGE_COUNT, messageCount);
  },

  /**
   * 获取未读消息
   */
  async [actionTypes.GET_UNREAD_MESSAGE]({ commit, state }) {
    let message = [];
    let result = await consolePanelReq.getUnreadMessage();

    if (Number(result.data.code) === 0) {
      if(result.data.res.totalCount >= 5) {
        message = result.data.res.list.slice(0, 5)
      } else {
        message = result.data.res.list;
      }
    }
    commit(mutationTypes.SET_UNREAD_MESSAGE, message);
  },

  /**
   * 获取未处理工单
   */
  async [actionTypes.GET_PENDING_ORDER]({ commit, state }) {
    let pendingOrder;
    // let userInfo = JSON.parse(localStorage.getItem("user")) || {};
    // let userId = userInfo.uuid;
    if (state.userInfo.type == 'PUBLIC') {
      let result = await consolePanelReq.getPendingOrder();

      if (Number(result.data.code) === 0) {
        pendingOrder = result.data.res.list
      }
      commit(mutationTypes.SET_PENDING_ORDER, pendingOrder);
    }
  }
}
